import { motion } from "framer-motion";
import { Sparkle } from "@phosphor-icons/react";

export default function FloatingCTA() {
  return (
    <motion.a
      href="#early-access"
      data-testid="floating-waitlist-btn"
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.2, duration: 0.5 }}
      whileHover={{ y: -3 }}
      className="fixed bottom-6 right-6 z-40 hidden sm:inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-emerald-700 to-emerald-800 px-5 py-3 text-sm font-semibold text-white shadow-glow-blue"
    >
      <Sparkle weight="fill" size={18} />
      Join Waitlist
    </motion.a>
  );
}
